module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.question.fields), function(field) {
    return _c(_vm.getFieldComponent(field), {
      key: field.uuid,
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "field": field,
        "fieldAnswer": _vm.getFieldAnswer(field),
        "isDisabled": _vm.disabledAttribute
      },
      on: {
        "fieldUpdated": _vm.onFieldUpdated
      }
    })
  }), 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225c451a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/FormQuestion.vue
// module id = 703
// module chunks = 1